
import { Link } from "react-router-dom";
import { useCategories } from "@/hooks/useCategories";
import { Loader2 } from "lucide-react";

export const CategorySection = () => {
  const { categories, isLoading } = useCategories();
  
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Popular Categories</h2>
          <Link to="/categories" className="text-chapterly-purple hover:underline">
            View all
          </Link>
        </div>
        
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin mr-2" />
            <span>Loading categories...</span>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {categories.slice(0, 10).map((category) => (
              <Link 
                key={category.id} 
                to={`/category/${category.slug}`} 
                className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center hover:bg-chapterly-soft-purple"
              >
                <h3 className="font-medium">{category.name}</h3>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
